import { nextTick } from 'vue'

export function scrollToTop() {
  const ua = navigator.userAgent

  // Detect Chromium-based browsers (Chrome, Edge, Opera, Brave, etc.)
  const isChromium = /\b(Chrome|Chromium|Edg|OPR)\b/.test(ua) && !/Firefox|Safari/.test(ua)

  if (isChromium) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  } else {
    smoothScrollToTopFallback()
  }
}

function smoothScrollToTopFallback(duration = 300) {
  const start = window.scrollY || window.pageYOffset
  const startTime = performance.now()

  function step(now) {
    const elapsed = now - startTime
    const t = Math.min(1, elapsed / duration)
    const eased = 1 - Math.pow(1 - t, 3)

    window.scrollTo(0, Math.round(start * (1 - eased)))

    if (t < 1) {
      requestAnimationFrame(step)
    }
  }

  requestAnimationFrame(step)
}

export default {
  mounted() {
    nextTick(() => {
      scrollToTop()
    })
  },
}
